import React from 'react'
import { get as getCookie } from 'es-cookie'
import { StoreProvider, createStore } from 'easy-peasy'
import { authModel } from '../models/auth'
import { menusModel } from '../models/menus'

const authStore = createStore({
  ...authModel,
  ...menusModel,
})

export const IdentityStore = ({ children }) => {
  React.useEffect(() => {
    if (getCookie('wtwJWT')) authStore.dispatch.auth.loginUser()
    else authStore.dispatch.auth.setAuthStage('SIGNED_OUT')
  }, [])

  return <StoreProvider store={authStore}>{children}</StoreProvider>
}
